import * as constants from "./actionTypes";

export const setUser = (payload) => {
  return {
    type: constants.SET_USER,
    payload,
  };
};

export const setCartItems = (payload) => {
  return {
    type: constants.SET_CART_ITEMS,
    payload,
  };
};
export const setSideBarVisibility = (payload) => {
  return {
    type: constants.SET_SIDE_BAR_VISIBILITY,
    payload,
  };
};

export const setMyCartModalVisibility = (payload) => {
  return {
    type: constants.SET_MY_CART_MODAL_VISIBILITY,
    payload,
  };
};
